<template>
  <div class="rightContainer">
    <div class="correlationHot">
      <div>热门文章</div>
      <div @click="articleSwitch1" class="point">
        换一换<img style="margin-left: 10px;" src="~@/assets/img/frontierPage/change.png" />
      </div>
    </div>
    <div class="cut-off"></div>
    <div v-for="item in articleHot" @click="detailJump(item)" class="titlePopular">
      <img src="~@/assets/img/frontierPage/article-title-ellipse.png" />{{ item.title }}
    </div>
    <div class="correlationHot">
      <div>热门标签</div>
      <div class="point" @click="switchingLabel">
        换一换<img style="margin-left: 10px;" src="~@/assets/img/frontierPage/change.png" />
      </div>
    </div>
    <div class="cut-off"></div>
    <div class="">
      <div @click="jumpTag(item)" v-for="item in tagHot" class="tag">{{ item.name }}</div>
    </div>
    <div class="correlationHot">
      <div>相关文章</div>
      <div class="point" @click="articleSwitch2">
        换一换<img style="margin-left: 10px;" src="~@/assets/img/frontierPage/change.png" />
      </div>
    </div>
    <div class="cut-off"></div>
    <div v-for="item in articleRelevance" @click="detailJump(item)" class="titleRelated">
      <img src="~@/assets/img/frontierPage/article-title-ellipse.png" />
      {{ item.title }}
    </div>
  </div>
</template>

<script>
  import {contentTagByCount, getContentInfo} from "../api/frontierPage";

  export default {
    name: "FrontierRightPage",
    data() {
      return{
        articleHot: [],
        articleRelevance: [],
        tagHot: [],
        maximumLabel: 0,
        pageMaximum1: 0,
        pageMaximum2: 0,
        tagArticleData: {
          channelId:291,
          pageSize: 10,
        },
        numberPage1: 1,
        numberPage2: 1,
        pageLabel: 1,
      }
    },
    methods: {
      detailJump(item) {
        item.channelId = this.tagArticleData.channelId;
        this.$emit('openDetail',item)
      },
      articleSwitch1() {
        let self = this
        self.numberPage1++;
        if (self.numberPage1 > self.pageMaximum1) self.numberPage1 = 1;
        self.tagArticleData.pageNo = self.numberPage1
        self.tagArticleData.sort = 'contentCount'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200)
            self.articleHot = res.data.content;
        });
      },
      switchingLabel() {
        const self = this;
        self.pageLabel++;
        if (self.pageLabel > self.maximumLabel) self.pageLabel = 1;
        self.tagArticleData.pageNo = self.pageLabel
        contentTagByCount(self.tagArticleData).then((res) => {
          if (res.status === 200) {
            self.tagHot = res.data.content;
          }
        });
      },
      articleSwitch2() {
        const self = this;
        self.numberPage2++;
        if (self.numberPage2 > self.pageMaximum2) self.numberPage2 = 1;
        self.tagArticleData.pageNo = self.numberPage2
        self.tagArticleData.sort = 'topLevel'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200)
            self.articleRelevance = res.data.content;
        });
      },
      jumpTag(item) {
        this.$emit('jumpTag',item)
      },
      contentTagByCount() {
        const self = this;
        self.tagArticleData.pageNo = 1
        contentTagByCount(self.tagArticleData).then((res) => {
          if (res.status === 200) {
            this.tagHot = res.data.content;
            this.maximumLabel = Math.ceil(res.data.total / 10);
          }
        });
      },
      getContentInfo_channelId() {
        let self = this
        self.tagArticleData.pageNo = 1
        self.tagArticleData.sort = 'contentCount'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200) {
            self.articleHot = res.data.content;
            self.pageMaximum1 =  Math.ceil(res.data.total / 10);
          }
        });
        self.tagArticleData.sort = 'topLevel'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200) {
            self.articleRelevance = res.data.content;
            self.pageMaximum2 =  Math.ceil(res.data.total / 10);
          }
        });
      }
    },
    mounted() {
      const self = this;
      self.getContentInfo_channelId()
      self.contentTagByCount()
    }
  }
</script>

<style scoped>
  .point {cursor: pointer}
  .rightContainer .correlationHot {justify-content: space-between;display: flex;}
  .rightContainer .correlationHot:nth-of-type(n + 2) {margin-top: 30px;}
  .rightContainer .correlationHot > div:nth-of-type(1) {font-size: 18px;font-weight: bold;color: #3e3a39;}
  .rightContainer .correlationHot > div:nth-of-type(2) {font-size: 14px;font-weight: 400;color: #999999;}
  .rightContainer .cut-off {margin-top: 14px;margin-bottom: 27px;background: #e7ecf0;height: 1px;}
  .rightContainer .titlePopular, .rightContainer .titleRelated {margin-top: 22px;font-size: 14px;font-weight: 400;color: #3e3a39;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;cursor: pointer;}
  .rightContainer .titlePopular img,.rightContainer .titleRelated img{margin-right: 16px;}
  .tag {margin-right: 10px;margin-bottom: 10px;display: inline-block;width: max-content;padding: 10px;color: #408cf6;cursor: pointer;background: url('~@/assets/img/frontierPage/tag.png');background-size: 100% 100%;font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/components/FrontierRightPage.vue